import { createAsyncThunk, createReducer, createSelector } from "@reduxjs/toolkit";

import { fetchWithAuth } from "~/common/fetch";
import { API_BANNERS } from "~/config";
import type { RootState } from "~/store";
import type { MutableQueryState } from "~/types/redux";

export type TBanner = {
  id: number;
  type: "link" | "private_file" | "public_file" | "empty";
  position: number;
  align: "left" | "center" | "center_and_left";
  icon_url: string;
  banner_url: string | null;
  link: string | null;
  description: string | null;
};

const initialState: MutableQueryState<TBanner[]> = {
  status: "idle",
  data: undefined,
  error: undefined,
};

export const getBanners = createAsyncThunk("banners/fetch", async () => {
  const response = await fetchWithAuth(API_BANNERS);

  if (!response.ok) {
    throw new Error(`Error occurred trying to fetch banners: ${response.statusText}`);
  }

  return (await response.json()) as TBanner[];
});

const selectBannersData = (state: RootState) => state.banners.data;

export const selectBanners = createSelector(
  [selectBannersData],
  (bannersData) => bannersData ?? [],
);

export const banners = createReducer(initialState, (builder) =>
  builder
    .addCase(getBanners.pending, (state) => {
      state.status = "loading";
    })
    .addCase(getBanners.fulfilled, (state, action) => {
      state.status = "success";
      state.data = action.payload;
      state.error = undefined;
    })
    .addCase(getBanners.rejected, (state, action) => {
      state.status = "error";
      state.data = undefined;
      state.error = action.error;
    }),
);
